import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField } from "../FormField";
import { PasswordField } from "../fields/PasswordField";
import { RegisterFormData } from "../schema";

interface AccountSectionProps {
  control: Control<RegisterFormData>;
  showPassword: boolean;
  showConfirmPassword: boolean;
  togglePasswordVisibility: () => void;
  toggleConfirmPasswordVisibility: () => void;
}

export const AccountSection = ({
  control,
  showPassword,
  showConfirmPassword,
  togglePasswordVisibility,
  toggleConfirmPasswordVisibility,
}: AccountSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        name="email"
        control={control}
        label={
          <>
            {t("register.labels.email")}
            <span className="text-red-500">*</span>
          </>
        }
        placeholder={t("register.placeholders.email")}
        type="email"
      />
      <FormField
        name="emailConfirm"
        control={control}
        label={
          <>
            {t("register.labels.emailConfirm")}
            <span className="text-red-500">*</span>
          </>
        }
        placeholder={t("register.placeholders.emailConfirm")}
        type="email"
      />
      <PasswordField
        name="password"
        control={control}
        label={
          <>
            {t("register.labels.password")}
            <span className="text-red-500">*</span>
          </>
        }
        placeholder={t("register.placeholders.password")}
        showPassword={showPassword}
        togglePassword={togglePasswordVisibility}
      />
      <PasswordField
        name="passwordConfirm"
        control={control}
        label={
          <>
            {t("register.labels.passwordConfirm")}
            <span className="text-red-500">*</span>
          </>
        }
        placeholder={t("register.placeholders.passwordConfirm")}
        showPassword={showConfirmPassword}
        togglePassword={toggleConfirmPasswordVisibility}
      />
    </div>
  );
};